module.exports = __webpack_public_path__ + "static/media/layout-white.43093253.svg";